'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ElementCount = require('./ElementCount');

var _ElementCount2 = _interopRequireDefault(_ElementCount);

var _PlanStatusTitle = require('../../../../../user/account/plan/PlanStatusTitle');

var _PlanStatusTitle2 = _interopRequireDefault(_PlanStatusTitle);

var _ElectronLink = require('../../../../../components/electron/ElectronLink');

var _ElectronLink2 = _interopRequireDefault(_ElectronLink);

var _elementCountSelector = require('../../../../../user/elementCount/elementCountSelector');

var _userConstants = require('../../../../../../common/users/userConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var countSelector = (0, _reselect.createSelector)(_elementCountSelector.contentElementCountSelector, _elementCountSelector.contentTotalCountSelector, _elementCountSelector.contentTotalLimitSelector, function (elementCount, contentTotalCount, contentTotalLimit) {
    return {
        elementCount: elementCount,
        contentTotalCount: contentTotalCount,
        contentTotalLimit: contentTotalLimit
    };
});

var BillingTierFree = function BillingTierFree(props) {
    var contentTotalCount = props.contentTotalCount,
        contentTotalLimit = props.contentTotalLimit,
        buttonClass = props.buttonClass;


    var earnedContent = contentTotalLimit - _userConstants.CONTENT_LIMIT_FREE_BASE;

    return _react2.default.createElement(
        'div',
        { className: 'BillingStatusDisplay BillingTierFree' },
        _react2.default.createElement(
            'div',
            { className: 'plan-status' },
            _react2.default.createElement(_PlanStatusTitle2.default, { contentTotalCount: contentTotalCount, contentTotalLimit: contentTotalLimit })
        ),
        _react2.default.createElement(_ElementCount2.default, _extends({}, props, { contentTotalLimit: contentTotalLimit, showCountDetail: true })),
        _react2.default.createElement(
            'div',
            { className: 'plan-actions' },
            earnedContent > 0 ? _react2.default.createElement(
                'span',
                { className: 'earned' },
                'You\'ve earned ',
                earnedContent,
                ' extra cards'
            ) : null,
            _react2.default.createElement(
                _ElectronLink2.default,
                { to: '/account/plan', className: (0, _classnames2.default)(buttonClass || 'action', 'primary') },
                'Get more space'
            )
        )
    );
};

BillingTierFree.propTypes = {
    currentUser: _propTypes2.default.object,
    elementCount: _propTypes2.default.object,
    contentTotalCount: _propTypes2.default.number,
    contentTotalLimit: _propTypes2.default.number,
    buttonClass: _propTypes2.default.string
};

exports.default = (0, _reactRedux.connect)(countSelector)(BillingTierFree);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/billingStatus/BillingTierFree.js
// module id = 773
// module chunks = 0